import { render, staticRenderFns } from "./SMS.vue?vue&type=template&id=6de9f553&scoped=true"
import script from "./SMS.vue?vue&type=script&lang=js"
export * from "./SMS.vue?vue&type=script&lang=js"
import style0 from "./SMS.vue?vue&type=style&index=0&id=6de9f553&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de9f553",
  null
  
)

export default component.exports